module.exports = __webpack_public_path__ + "img/erp-logos_0011_shopify.1b598525.jpg";